
export default class BrowserHistoryManager {
    constructor() {
        this.states = [];
        this.acceptedParams = [];
        history.scrollRestoration = 'manual';
        this.initializeBackBehaviour();
        this.eventDelegation();
    }

    initializeBackBehaviour() {
        setTimeout(() => {
            const defaultBackEventElement = document.querySelector('[data-back-behaviour]');
            if (defaultBackEventElement) {
                const urlRedirect = defaultBackEventElement.getAttribute('data-redirect');
                const element = '[data-back-behaviour]';
                this.addState(element);
                defaultBackEventElement.addEventListener('pop-state', (event) => {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault()
                    if (urlRedirect) {
                        this.redirect(urlRedirect);
                        return;
                    }
                    this.showModal(defaultBackEventElement);
                    this.addState(element);
                });
            }
        }, 200);
    }

    eventDelegation() {
        this.onPopstateEvent();

        window.addEventListener('popstate', (event) => {
            if (this.states.length === 0) {
                return;
            }

            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
            let element = this.states.pop();
            let popStateEvent = new Event('pop-state');
            document.querySelector(element).dispatchEvent(popStateEvent);
        });

        document.addEventListener('removeHistoryState', (event) => {
            const eventId = event.detail.eventId;
            if (this.states.includes(eventId)) {
                this.removeState(eventId);
            }
        });

        document.addEventListener('addHistoryState', (event) => {
            const element = event.detail.eventId;
            if (!this.checkStateExists(element)) {
                this.addState(element);
            }
        });
    };

    addState(element) {
        this.states.push(element);
        history.pushState({element: element}, "", window.location.href);
    }

    removeState(element) {
        if (history.state && history.state.element === element) {
            history.back();
        }
    }

    showModal(openModalElement) {
        let openModalEvent = new Event('open-modal-on-back');
        openModalElement.dispatchEvent(openModalEvent);
    };

    redirect(urlRedirect) {
        if (urlRedirect) {
            window.location.href = urlRedirect;
        }
    }

    getLastStateItem() {
        if (this.states.length === 0) {
            return;
        }
        return this.states[this.states.length - 1];
    }

    checkStateExists(element) {
        return this.states.indexOf(element) !== -1;
    }

    onPopstateEvent() {
        if (document.querySelectorAll('gallery-modal').length === 0) {
            return;
        }

        for (let modal of document.querySelectorAll('gallery-modal')) {
            let id = '[data-gallery-modal="' + modal.getAttribute('data-gallery-modal') + '"]';

            modal.shadowRoot.addEventListener('show', () => {
                this.addState(id);
            })

            modal.shadowRoot.addEventListener('hide', () => {
                this.removeState(id);
            })

            document.querySelector(id).addEventListener('pop-state', () => {
                modal._dismissModal();
            });
        }
    }

    setCustomParam(){}
}

BrowserHistoryManager.className = 'browserHistoryManager';
